import { render, staticRenderFns } from "./addHonor.vue?vue&type=template&id=b5d20e58&scoped=true"
import script from "./addHonor.vue?vue&type=script&lang=js"
export * from "./addHonor.vue?vue&type=script&lang=js"
import style0 from "./addHonor.vue?vue&type=style&index=0&id=b5d20e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d20e58",
  null
  
)

export default component.exports